<template>
  <navbar
    position="fixed"
    type="success"
    :transparent="transparent"
    :color-on-scroll="colorOnScroll"
    menu-classes="ml-auto"
  >
    <template>
      <router-link v-popover:popover1 class="navbar-brand" to="/">
        <img src="img/__logo option 1.png" width="190" height="48" style="height: auto;" alt="" />
        <p class="ml-3"></p>
      </router-link>
      <!-- <el-popover
        ref="popover1"
        popper-class="popover"
        placement="bottom"
        width="200"
        trigger="hover"
      >
        <div class="popover-body">
          Designed by Invision. Coded by Creative Tim
        </div>
      </el-popover> -->
    </template>
    <template slot="navbar-menu">
      <li class="nav-item mr-2">
        <router-link v-popover:popover1 class="navbar-brand" to="/">
         <!-- <i class="now-ui-icons shopping_shop mr-1"></i> -->  <h5 style="font-weight: bold; font-size: 15px;">{{ $t('common.nav.home') }}</h5>
        </router-link>
      </li>
      <!-- <li class="nav-item">
        <router-link v-popover:popover1 class="navbar-brand" to="/about-us">
          <p><i class="now-ui-icons business_badge mr-1"></i> <span >About Us</span></p>
        </router-link>
      </li> -->
      <drop-down
        tag="li"
        :title="$t('common.nav.aboutUs')"
        style="font-weight: bold; margin-top: -2px;"
        class="nav-item mr-3"
      >
        <nav-link to="/about-us">
          {{ $t('common.nav.aboutUs') }}
        </nav-link>
        <nav-link to="/facilities">
          {{ $t('common.nav.facilities') }}
        </nav-link>
        <nav-link to="/certification">
          {{ $t('common.nav.certification') }}
        </nav-link>
        <nav-link to="/portofolio">
          {{ $t('common.nav.portofolio') }}
        </nav-link>
      </drop-down>
      <li class="nav-item mr-3">
        <router-link v-popover:popover1 class="navbar-brand" to="/service">
          <h5 style="font-weight: bold; font-size: 15px;"><!-- <i class="now-ui-icons ui-2_settings-90 mr-1"></i> --> <span >{{ $t('common.nav.service') }}</span></h5>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link v-popover:popover1 class="navbar-brand" to="/career">
          <h5 style="font-weight: bold; font-size: 15px;"><!-- <i class="now-ui-icons ui-2_settings-90 mr-1"></i> --> <span >{{ $t('common.nav.career') }}</span></h5>
        </router-link>
      </li>
      <li class="nav-item mr-3">
        <router-link v-popover:popover1 class="navbar-brand" to="/blog">
          <h5 style="font-weight: bold; font-size: 15px;"><!-- <i class="now-ui-icons education_agenda-bookmark mr-1"></i> --> <span >{{ $t('common.nav.newsBlog') }}</span></h5>
        </router-link>
      </li>
      <li class="nav-item mr-3">
        <router-link v-popover:popover1 class="navbar-brand" to="/factory-tour">
          <h5 style="font-weight: bold; font-size: 15px;"><span >{{ $t('common.nav.factoryTour') }}</span></h5>
        </router-link>
      </li>
      <li class="nav-item mr-3">
        <router-link v-popover:popover1 class="navbar-brand" to="/seminar">
          <h5 style="font-weight: bold; font-size: 15px;"><span >{{ $t('common.nav.seminar') }}</span></h5>
        </router-link>
      </li>
      <li class="nav-item">
        <!-- <router-link v-popover:popover1 class="navbar-brand" to="/login">
          <p><i class="now-ui-icons users_circle-08 mr-1"></i> <span >Login</span></p>
        </router-link> -->
       <!--  <div class="form-inline">
          <n-button type="warning" size="sm" class="float-right mr-3" @click="logout()"> Logout</n-button>
        </div> -->
      </li>
      <!-- <drop-down
        tag="li"
        title="Components"
        icon="now-ui-icons design_app"
        class="nav-item"
      >
        <nav-link to="/">
          <i class="now-ui-icons business_chart-pie-36"></i> All components
        </nav-link>
        <a
          href="https://demos.creative-tim.com/vue-now-ui-kit/documentation"
          target="_blank"
          class="dropdown-item"
        >
          <i class="now-ui-icons design_bullet-list-67"></i> Documentation
        </a>
      </drop-down> -->
      <!-- <drop-down
              tag="li"
              title="Examples"
              icon="now-ui-icons design_image"
              class="nav-item"
      >
        <nav-link to="/landing">
          <i class="now-ui-icons education_paper"></i> Landing
        </nav-link>
        <nav-link to="/login">
          <i class="now-ui-icons users_circle-08"></i> Login
        </nav-link>
        <nav-link to="/profile">
          <i class="now-ui-icons users_single-02"></i> Profile
        </nav-link>
      </drop-down> -->
      <li class="nav-item">
        <router-link v-popover:popover1 class="nav-link btn btn-neutral" to="/contact-us" style="white-space: nowrap;">
          <p style="white-space: nowrap;"><span style="font-weight: bold; color: #008c45;">{{ $t('common.nav.contactUs') }}</span></p>
        </router-link>
      </li>
      <drop-down
        tag="li"
        :title="currentLocaleLabel"
        style="font-weight: bold; margin-top: -2px;"
        class="nav-item ml-3"
      >
        <a class="dropdown-item" href="#" @click.prevent="setLocale('id')">Indonesia</a>
        <a class="dropdown-item" href="#" @click.prevent="setLocale('en')">English</a>
        <a class="dropdown-item" href="#" @click.prevent="setLocale('ja')">日本語</a>
      </drop-down>

      <!-- <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Twitter"
          data-placement="bottom"
          href="https://twitter.com/CreativeTim"
          target="_blank"
        >
          <i class="fab fa-twitter"></i>
          <p class="d-lg-none d-xl-none">Twitter</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Like us on Facebook"
          data-placement="bottom"
          href="https://www.facebook.com/CreativeTim"
          target="_blank"
        >
          <i class="fab fa-facebook-square"></i>
          <p class="d-lg-none d-xl-none">Facebook</p>
        </a>
      </li>
      <li class="nav-item">
        <a
          class="nav-link"
          rel="tooltip"
          title="Follow us on Instagram"
          data-placement="bottom"
          href="https://www.instagram.com/CreativeTimOfficial"
          target="_blank"
        >
          <i class="fab fa-instagram"></i>
          <p class="d-lg-none d-xl-none">Instagram</p>
        </a>
      </li> -->
    </template>
  </navbar>
</template>

<script>
import { DropDown, Navbar, NavLink, Button } from '@/components';
import { Popover } from 'element-ui';
import { updateHead } from '@/utils/head';

export default {
  name: 'main-navbar',
  props: {
    transparent: Boolean,
    colorOnScroll: Number
  },
  components: {
    DropDown,
    Navbar,
    NavLink,
    [Popover.name]: Popover,
    [Button.name]: Button,
  },
  computed: {
    currentLocaleLabel() {
      const labels = { id: 'ID', en: 'EN', ja: 'JP' };
      return labels[this.$i18n.locale] || 'ID';
    },
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem('locale', locale);
      updateHead(this.$route);
    },
  }
};
</script>

<style>
@media (max-width: 991px) {
  nav.navbar .navbar-collapse.navbar-collapse {
    background: linear-gradient(160deg, #006633 0%, #00a651 100%) !important;
    padding: 20px 15px 30px;
  }

  nav.navbar .navbar-collapse.navbar-collapse::before,
  nav.navbar .navbar-collapse.navbar-collapse:before {
    background: linear-gradient(160deg, #006633 0%, #00a651 100%) !important;
    opacity: 1 !important;
  }

  nav.navbar .navbar-collapse .nav-item {
    margin-bottom: 8px;
  }

  nav.navbar .navbar-collapse .nav-link,
  nav.navbar .navbar-collapse .dropdown-toggle {
    padding: 8px 15px;
  }

  nav.navbar .navbar-collapse .dropdown-menu {
    background: rgba(255, 255, 255, 0.12);
    border-radius: 10px;
    margin-top: 2px;
    margin-bottom: 6px;
    padding: 4px 10px;
    box-shadow: none;
  }

  nav.navbar .navbar-collapse .dropdown-menu .dropdown-item {
    color: #fff;
    padding: 8px 10px;
  }

  nav.navbar .navbar-collapse .dropdown-menu .dropdown-item:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  nav.navbar .navbar-collapse .btn-neutral {
    margin-top: 4px;
  }
}

@media (min-width: 992px) {
  nav.navbar .navbar-nav > li > .dropdown-toggle.nav-link {
    font-size: 15px !important;
  }

  nav.navbar .navbar-translate {
    flex-shrink: 0;
  }

  nav.navbar .navbar-brand img {
    width: 150px;
    height: auto;
  }
}
</style>
